import { Images } from '@/assets/images';
import { DocTypeEnum, REGEX } from '@/constant';
import { cls, dayjs, formatDate } from '@/utils';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	franchiseName: '',
	registryNo: '',
	franchiseAddress: '',
	franchisePhone: '',
	phone: '',
	email: '',
	createDate: '',
	franchiseSignatureName: '',
	franchiseSignature: '',
	addresseeOfficial: '',
	district: '',
};

type IValues = typeof initializeValue;

export const WAGE_GUARANTEE_COMMITMENT_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.FRF_13
> = {
	initializeValue,
	title: '임금체불 보증보험 가입 확약서',
	mapPropToValues: ({ franchiseData, detailData }) => {
		const { unitInfo } = detailData || {};
		return {
			createDate: formatDate(dayjs()),
			franchiseName: franchiseData?.name || '',
			franchiseAddress: franchiseData?.address || '',
			registryNo:
				`${formatDate(franchiseData?.employerBirthDate, { outputFormat: 'YYMMDD' })} / ${franchiseData?.businessRegistNo}` ||
				'',
			franchisePhone: franchiseData?.phone || '',
			phone: franchiseData?.employerPhone,
			franchiseSignatureName: franchiseData?.employerName || '',
			addresseeOfficial: unitInfo?.name || '',
			email: franchiseData?.email || '',
			district: `${unitInfo?.cityProvince} ${unitInfo?.countyDistrict ? `(${unitInfo?.countyDistrict})` : ''}`,
		};
	},
	pages: [
		{
			background: {
				src: Images.formWageGuaranteeCommitment,
				className: 'template',
				dataSource: Images.formWageGuaranteeCommitment,
			},
			textAreas: [
				(values, index) => ({
					name: 'franchiseName',
					maxHeight: 40,
					className: 'text-[13px] text-left',
					containerClassName: cls(
						'absolute top-[221px] left-[65px] !h-[40px] w-[302px]',
						values?.franchiseName && 'bg-white'
					),
					maxLength: 20,
				}),
				(values, index) => ({
					name: 'registryNo',
					maxHeight: 40,
					className: 'text-[13px] text-left',
					containerClassName: cls(
						'absolute top-[221px] left-[374px] !h-[40px] w-[315px]'
						// values?.registryNo && 'bg-white'
					),
					maxLength: 35,
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'franchiseAddress',
					maxHeight: 20,
					className: 'text-[13px] text-left',
					containerClassName: cls(
						'absolute top-[288px] left-[65px] !h-[21px] w-[625px]'
						// values?.franchiseAddress && 'bg-white'
					),
					maxLength: 60,
				}),
				(values, index) => ({
					name: 'franchisePhone',
					maxHeight: 20,
					className: 'text-[13px] text-left',
					containerClassName: cls(
						'absolute top-[343px] left-[65px] !h-[21px] w-[298px]'
						// values?.franchisePhone && 'bg-white'
					),
					maxLength: 14,
					regex: REGEX.ALLOW_NUMBER_DASH,
				}),
				(values, index) => ({
					name: 'phone',
					maxHeight: 20,
					className: 'text-[13px] text-left',
					containerClassName: cls(
						'absolute top-[343px] left-[374px] !h-[21px] w-[315px]'
						// values?.phone && 'bg-white'
					),
					maxLength: 14,
					regex: REGEX.ALLOW_NUMBER_DASH,
				}),
				(values, index) => ({
					name: 'email',
					maxHeight: 20,
					className: 'text-[13px] text-left',
					containerClassName: cls(
						'absolute top-[393px] left-[65px] !h-[21px] w-[623px]'
						// values?.email && 'bg-white'
					),
					maxLength: 60,
				}),
				{
					name: 'franchiseSignatureName',
					maxHeight: 40,
					className: 'text-[13px] text-left',
					containerClassName: cls(
						'absolute top-[754px] left-[334px] !h-[21px] w-[152px]'
					),
					maxLength: 20,
				},
				(values, index) => ({
					name: 'district',
					maxHeight: 40,
					className: 'text-[13px] text-left',
					containerClassName: cls(
						'absolute top-[834px] left-[189px] w-[122px]'
					),
					maxLength: 35,
				}),
			],
			datePickers: [
				{
					name: 'createDate',
					segmentedInputs: true,
					format: 'YYYY               MM              DD',
					containerClassName: 'absolute top-[703px] left-[269px]',
					style: { fontSize: '14px' },
					boxStyle: { marginTop: '-7px' },
				},
			],
			signatures: [
				{
					name: 'franchiseSignature',
					className: 'absolute top-[755px] left-[487px] !h-[48px] w-[125px]',
				},
			],
			highlightBoxes: [
				{
					name: 'franchiseName',
					className: 'top-[198px] left-[65px] !h-[21px] w-[85px]',
				},
				{
					name: 'registryNo',
					className: 'top-[198px] left-[374px] !h-[21px] w-[320px]',
				},
				{
					name: 'franchiseAddress',
					className: 'top-[264px] left-[65px] !h-[21px] w-[139px]',
				},
				{
					name: 'franchisePhone',
					className: 'top-[319px] left-[65px] !h-[21px] w-[110px]',
				},
				{
					name: 'phone',
					className: 'top-[319px] left-[374px] !h-[21px] w-[100px]',
				},
				{
					name: 'email',
					className: 'top-[373px] left-[65px] !h-[21px] w-[120px]',
				},
				{
					name: 'createDate',
					className: 'top-[696px] left-[266px] !h-[21px] w-[200px]',
				},
				{
					name: 'franchiseSignatureName',
					className: 'top-[754px] left-[140px] !h-[21px] w-[189px]',
				},
				{
					name: 'franchiseSignature',
					className: 'top-[754px] left-[487px] !h-[21px] w-[125px]',
				},
				{
					name: 'district',
					className: 'top-[841px] left-[189px] !h-[24px] w-[122px]',
				},
			],
		},
	],
};
